import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { rootUrl } from '../config/config';

const PayersContext = createContext();

export const PayersProvider = ({ children }) => {
    const [payers, setPayers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchPayers();
    }, []);

    const fetchPayers = async () => {
        try {
            setLoading(true);
            setError(null);
            const response = await axios.get(`${rootUrl}/api/system/payers/active`);
            if (response.data.success) {
                setPayers(response.data.data);
            } else {
                setPayers([]);
                setError('Failed to fetch payers');
            }
        } catch (err) {
            console.error('Error fetching payers:', err);
            setError(err.message);
            setPayers([]);
        } finally {
            setLoading(false);
        }
    };

    const refreshPayers = async () => {
        await fetchPayers();
    };

    return (
        <PayersContext.Provider value={{ payers, loading, error, refreshPayers }}>
            {children}
        </PayersContext.Provider>
    );
};

export const usePayers = () => {
    const context = useContext(PayersContext);
    if (!context) {
        throw new Error('usePayers must be used within a PayersProvider');
    }
    return context;
};
